import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { RegionComunaDTO } from 'app/main/apps/shared/interfaces/region-comuna.interface';
import { CodigosService } from 'app/main/apps/shared/services/rest/codigos.service';


@Component({
  selector: 'app-tabla-comunas',
  templateUrl: './tabla-comunas.component.html',
  styleUrls: ['./tabla-comunas.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class TablaComunasComponent implements OnInit {

  @Input() comunas:RegionComunaDTO[];
  @Input() procesando:boolean;
  @Output() guardarRecargoEvent: EventEmitter<RegionComunaDTO> = new EventEmitter();

  dataSource: MatTableDataSource<RegionComunaDTO> | null;
  displayedColumns = ['nombre', 'recargo', 'guardar'];


  constructor(private _codigos:CodigosService) { }

  ngOnInit(): void {
    this._codigos.recargarComunasChange$.subscribe(resp=>{
      this.procesando=resp;
    })

    this._codigos.comunasChanged$.subscribe(resp=>{
      console.log('llego al subscribe');
      this.procesando=false;
      this.dataSource = new MatTableDataSource(resp);
    });     
    this.dataSource = new MatTableDataSource(this.comunas);
  }

  cambia($event,comuna:RegionComunaDTO){
    //console.log(comuna);
  }


  guardar(comuna:RegionComunaDTO){
    this.procesando=true;
    this.guardarRecargoEvent.emit(comuna);
  }

}
